import React, { useEffect, useState } from "react";
import CreatePrefferPartner from "./CreatePrefferPartner";
import Swal from "sweetalert2";
import EditPrefferPartner from "./EditPrefferPartner";
import {
  deletePrefferPartner,
  getAllPrefferPartner,
} from "../../api/PrefferPartner";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "boxicons/css/boxicons.min.css";
import "../../vendor/css/viewprefferpartner.css";

const ViewPrefferPartner = () => {
  const [prefferPartnerList, setPrefferPartnerList] = useState([]);
  const [selectedPrefferPartner, setSelectedPrefferPartner] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const partnersPerPage = 10;

  useEffect(() => {
    const getPrefferPartnerList = async () => {
      try {
        const response = await getAllPrefferPartner();
        setPrefferPartnerList(response?.prefferPartners || response || []);
      } catch (error) {
        console.error("Error fetching preferred partners:", error);
        Swal.fire("Error", "Failed to load preferred partners", "error");
      } finally {
        setLoading(false);
      }
    };
    getPrefferPartnerList();
    const interval = setInterval(getPrefferPartnerList, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, []);

  // create and edit model state defind here
  const [createPrefferPartnerModelShow, setCreatePrefferPartnerModelShow] =
    useState(false);
  const handleCreateModalClose = () => setCreatePrefferPartnerModelShow(false);
  const handleCreateModalShow = () => setCreatePrefferPartnerModelShow(true);
  const [editPrefferPartnerModelShow, setEditPrefferPartnerModelShow] =
    useState(false);
  const handleEditModalClose = () => setEditPrefferPartnerModelShow(false);
  const handleEditModalShow = () => setEditPrefferPartnerModelShow(true);

  // Filter partners based on search term
  const filteredPartners = prefferPartnerList.filter(partner =>
    partner.partner_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastPartner = currentPage * partnersPerPage;
  const indexOfFirstPartner = indexOfLastPartner - partnersPerPage;
  const currentPartners = filteredPartners.slice(indexOfFirstPartner, indexOfLastPartner);
  const totalPages = Math.ceil(filteredPartners.length / partnersPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDeletePrefferPartner = (prefferPartnerToDelete) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deletePrefferPartner(prefferPartnerToDelete)
          .then((res) => {
            if (res.status === 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              setPrefferPartnerList((prev) =>
                prev.filter((item) => item._id !== prefferPartnerToDelete._id)
              );
            }
          })
          .catch((err) => {
            console.error("Delete failed:", err);
            Swal.fire("Error", "Failed to delete partner", "error");
          });
      }
    });
  };

  if (loading) {
    return (
      <div className="view-partners">
        <div className="partners-header">
          <h1>Preferred Partners Management</h1>
          <p>Manage and view all preferred partners</p>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading partners...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="view-partners">
      <div className="partners-header">
        <h1 style={{ fontFamily: 'serif' }}>Preferred Partners Management</h1>
        <p style={{ fontFamily: 'serif' }}>Manage and view all preferred partners</p>
      </div>

      <div className="partners-stats">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bx bx-group"></i>
          </div>
          <div className="stat-content">
            <h3>{prefferPartnerList.length}</h3>
            <p>Total Partners</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bx bx-search"></i>
          </div>
          <div className="stat-content">
            <h3>{filteredPartners.length}</h3>
            <p>Filtered Results</p>
          </div>
        </div>
      </div>

      <div className="partners-controls">
        <div className="search-container">
          <i className="bx bx-search search-icon"></i>
          <input
            type="text"
            placeholder="Search by partner name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        <button
          className="btn btn-primary add-partner-btn"
          onClick={handleCreateModalShow}
        >
          <i className="bx bx-plus"></i>
          Add Partner
        </button>
      </div>

      <div className="partners-grid">
        {currentPartners.length > 0 ? (
          currentPartners.map((partner, index) => (
            <div key={partner._id || index} className="partner-card">
              <div className="partner-image">
                <img
                  src={partner.image}
                  alt={partner.partner_name}
                  onError={(e) => {
                    e.target.src = '/assest/images/AacoreHoliday-logo.png';
                  }}
                />
              </div>
              <div className="partner-info">
                <h3>{partner.partner_name}</h3>
                <div className="partner-actions">
                  <button
                    className="btn btn-primary edit-btn"
                    onClick={() => {
                      setSelectedPrefferPartner(partner);
                      handleEditModalShow();
                    }}
                    title="Edit Partner"
                  >
                    <i className="bx bx-edit"></i>
                    Edit
                  </button>
                  <button
                    className="btn btn-danger delete-btn"
                    onClick={() => handleDeletePrefferPartner(partner)}
                    title="Delete Partner"
                  >
                    <i className="bx bx-trash"></i>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">
            <div className="no-data-content">
              <i className="bx bx-handshake-x"></i>
              <p>No partners found</p>
              <small>Try adjusting your search criteria</small>
            </div>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            <i className="bx bx-chevron-left"></i>
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => paginate(i + 1)}
              className={`pagination-btn ${currentPage === i + 1 ? 'active' : ''}`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            <i className="bx bx-chevron-right"></i>
          </button>
        </div>
      )}

      {/* Create Partner Modal */}
      <Modal
        show={createPrefferPartnerModelShow}
        onHide={handleCreateModalClose}
        className="partner-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Partner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreatePrefferPartner
            onSuccess={(res) => {
              console.log(res);
              setCreatePrefferPartnerModelShow(false);
              setPrefferPartnerList(res?.prefferPartner || res);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCreateModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Partner Modal */}
      <Modal
        show={editPrefferPartnerModelShow}
        onHide={handleEditModalClose}
        className="partner-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Partner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditPrefferPartner
            prefferPartner={selectedPrefferPartner}
            onSuccess={(res) => {
              setEditPrefferPartnerModelShow(false);
              setPrefferPartnerList(res?.prefferPartner || res);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleEditModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewPrefferPartner;
